import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, App } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { HomePage } from '../home/home';

@Component({
  selector: 'page-view-change-log',
  templateUrl: 'view-change-log.html',
})
export class ViewChangeLogPage {
  public document_id: any;
  public log_data: any;
  public log_datas: any;
  public log_data_details: any;
  public income_details: any;
  public asset_details: any;
  public liability_details: any;
  public realEstate_details: any;
  public tentative_realEstate_details: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public db: AngularFirestore,
    public menuCtrl: MenuController,
    public app: App
  ) {
    var thiss = this;
    this.document_id = this.navParams.get("document_id");
    this.log_data = '';
    this.log_datas = '';
    let docRef1 = firebase.firestore().collection("changed_log").doc(this.document_id);
    docRef1.get().then(function(doc) {
      if (doc.exists) {
        thiss.log_data = doc.data();
        thiss.log_data_details = doc.data().applicant_details;
        thiss.income_details = doc.data().income_details;
        thiss.asset_details = doc.data().asset_details;
        thiss.liability_details = doc.data().liability_details;
        thiss.realEstate_details = doc.data().realEstate_details;
        thiss.tentative_realEstate_details = doc.data().tentative_realEstate_details;
        thiss.getContactDetails(thiss.log_data.contact_uid).subscribe((data)=>{
          thiss.log_datas = data;
        });
      }
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewChangeLogPage');
  }

  getContactDetails (uid){
    console.log(uid);
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',uid )).valueChanges ();
  }

  clickToHomepage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    nav.setRoot(HomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-change-log/view-change-log.ts